import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditLBUTypes extends Component {

    state = {
        lbuTypes: this.props.lbuTypes.join('\n')
    }

    onSave = () => {
        this.props.onSave({
            lbuTypes: this.state.lbuTypes.split('\n').join(',')
        })
    }

    render() {
        const { lbuTypes = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditLBUTypes"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="LBU types">
            <Form>
                <div>
                    <textarea 
                        placeholder="LBU types"
                        value={lbuTypes}
                        onChange={e => this.setState({ lbuTypes: e.target.value })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditLBUTypes



// WEBPACK FOOTER //
// ./src/components/LBUs/EditLBUTypes.js